import { Facebook, Instagram, Linkedin, MessageSquareText } from 'lucide-react'
import { NavLink } from 'react-router-dom'

import { useAuth } from '@/contexts'
import { GetYear } from '@/utils/get-year'

function LGPDLink() {
  return (
    <NavLink
      to="/lgpd-contacts"
      className="text-zinc-500 underline transition-colors duration-300 hover:text-bios-secondary aria-[current=page]:text-bios-secondary"
    >
      Tratamento de dados
    </NavLink>
  )
}

export function Footer() {
  const { signed } = useAuth()

  return (
    <div className="z-10 flex w-screen flex-col justify-between gap-5 bg-monochromatic-200 px-5 py-5 text-center text-zinc-500 shadow-footer lg:flex-row lg:text-start 2xl:px-24 2xl:py-10">
      <p className="text-sm font-semibold">
        &copy; {GetYear()} -{' '}
        <span data-wg-notranslate>6BIOS Tecnologias Ambientais</span> - Todos os
        direitos reservados.
      </p>

      {signed ? (
        <div className="flex items-center justify-center gap-5 xl:justify-start">
          <LGPDLink />
          <p className="flex items-center justify-center gap-1">
            <MessageSquareText /> info@6bios.com
          </p>
        </div>
      ) : (
        <div className="flex flex-col items-center justify-center gap-5 sm:flex-row xl:justify-start">
          <LGPDLink />
          <div className="flex items-center gap-5">
            <p className="font-bold">Siga a 6BIOS:</p>
            <a
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-all hover:drop-shadow-sm"
            >
              <Facebook />
            </a>
            <a
              href="https://www.linkedin.com/company/6bios/"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-all hover:drop-shadow-sm"
            >
              <Linkedin />
            </a>
            <a
              href="#"
              target="_blank"
              rel="noopener noreferrer"
              className="transition-all hover:drop-shadow-sm"
            >
              <Instagram />
            </a>
          </div>
        </div>
      )}
    </div>
  )
}
